// extracted by mini-css-extract-plugin
export var drawerContent = "_31-0";
export var valueBlock = "_31-1";
export var valueBlockFrom = "_31-2 _31-1";
export var valueBlockTo = "_31-3 _31-1";